import { store } from '@/decorators/store';
import { Post } from '@/entities/Post';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'PostStore' })
export class PostStore extends AbstractEntityStore<Post> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'name';
  protected entityValueKey = 'name';
}
